<template>
  <div class="g-flex g-row-center">
    <div class="total-width infos g-m-t-30">
      <div class="g-p-20">
        <p class="g-text-center g-font-24 main-text g-m-t-44">{{detail.title}}</p>
        <p class="remark-text g-font-14 g-m-t-10 g-text-center">{{detail.releaseTime}}</p>
        <div class="g-m-t-30">
          <div v-html="detail.content" class="htmlDiv"></div>
		  <div v-if="detail.videoUrl">
			  <video id="myVideo" :src="detail.videoUrl" controls></video>
		  </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import {noticeDetail} from "@/api/api.js"
export default {
  name: "notice-detail",
  data(){
    return{
		id:'',
      detail:{}
    }
  },
  mounted() {
	  this.id = this.$route.query.id
  	this.getNoticeDetail();
  },
  methods:{
	  getNoticeDetail(){
		  noticeDetail({
		  	id: this.id
		  }).then(res => {
		  	this.detail = res
		  })
	  }
  }
}
</script>

<style lang="scss" scoped>
  .infos{
    background: #fff;
    border-radius: 10px;
  }
</style>
<style scoped>
	.htmlDiv img {
		  max-width: 100%;
	}
	.htmlDiv video {
		  max-width: 100%;
	}
	video {
		max-width: 100%;
	}
	.total-width {
		min-height: calc(100vh - 400px);
	}
</style>